import React from "react";

import FormField from "../../../../components/form-field/FormField";
import { translationService } from "../../../../services/translation/TranslationService";

interface InspectionNameProps {
  name: string;
}

export function DisplayInspectionName(props: InspectionNameProps) {
  return (
    <FormField
      id="inspection-external-id"
      labelKey="inspections.DisplayInspectionId.label"
      readOnly
      fieldValue={props.name}
    />
  );
}

interface InspectionLinkedProject {
  project: string | undefined;
}

export function DisplayLinkedProject(props: InspectionLinkedProject) {
  return (
    <FormField
      id="inspection-project-name"
      labelKey="general.in-project"
      readOnly
      fieldValue={props.project || "-"}
    />
  );
}

interface DisplayInspectionRelevanceProps {
  isRelevant: boolean;
}

export function DisplayInspectionRelevance(props: DisplayInspectionRelevanceProps) {
  return (
    <FormField
      id="inspection-is-relevant"
      labelKey="inspections.DisplayInspectionRelevance.label"
      readOnly
      fieldValue={translationService.translate(
        props.isRelevant ? "general.inspection.relevant" : "general.inspection.outdated"
      )}
    />
  );
}
